export default "__VITE_ASSET__BZMZdper__"